<template>
  <div style="width: 80rem; margin:0 auto; text-align:right;">
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pages.currentPage"
      :page-size="pages.pageSize"
      :layout="layout"
      :total="pages.total"
      background
    >
    </el-pagination>
  </div>
  <!-- :page-sizes="[8, 12, 16, 20]" -->
</template>

<script>
export default {
  props: {
    pages: {
      type: Object,
      default: {
        // 当前页数量
        pageSize: 8,
        // 当前页
        currentPage: 1,
        // 总数
        total: 0
      }
    },
    layout: {
      type: String,
      default: "total, sizes, prev, pager, next, jumper"
    }
  },
  data() {
    return {};
  },
  methods: {
    //页面尺寸改变
    handleSizeChange(val) {
      this.$emit("sizeChange", val);
    },
    //页码改变
    handleCurrentChange(val) {
      this.$emit("currentChange", val);
    }
  }
};
</script>

<style lang="less" scoped>
.el-pagination {
    margin: 15px 0;
}
/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
  background: #F64723 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/common/Pagenation.vue